import Footer from './Footer';
import Header from './Headers/Header';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const Home = ({ loggedIn }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return (
    <div className="w-full overflow-hidden font-sans">
      <Header loggedIn={loggedIn} />

      {/* Hero Section */}
      <div className="relative flex flex-col justify-center">
        {/* Background Image */}
        <div className="absolute top-0 left-0 w-full h-full -z-10 bg-gray-100 overflow-hidden">
          <img
            src={isMobile ? "/Images/Group 712.webp" : "/Agents/Group 693.webp"}
            alt="Hero Background"
            className="w-full h-full object-cover"
          />
        </div>

        <div className="container mx-auto px-4 lg:px-[12rem] py-12 flex flex-col justify-center h-full">
          <div className="text-center mb-12">
            <h1 className="text-white text-3xl lg:text-5xl font-bold my-4">Medicare Guidance You Can Trust — Year After Year</h1>
            <h4 className="text-white text-xl lg:text-2xl px-4 md:px-12 lg:px-40 font-bold my-4">We help you understand your Medicare options and connect you with licensed insurance agents who can assist with plan selection based on your needs.</h4>
          </div>

          <div className="flex flex-col md:flex-row justify-center items-stretch gap-16">
            <div className="bg-white p-4 rounded shadow-lg max-w-[27rem] flex flex-col items-center">
              <div className='text-center pt-2'><img src="Images\home-image-1.webp" alt="" /></div>
              <h3 className='text-center font-bold text-xl my-2'>Speak With a Licensed Agent</h3>
              <p className='text-center text-gray-600 mb-4'>Your Agent helps you enroll, compare Medicare options, and choose the coverage that best fits your needs.</p>
              <div className='flex justify-center items-center mb-2'>
                {/* <div className='home-hero-section-box-img'></div> icon placeholder if needed */}
                <h5 className='font-bold text-gray-600 text-lg'> 📞 <a href="tel:+18008151943" className="hover:underline">1-800-815-1943</a></h5>
              </div>
              <p className='font-bold text-gray-600 text-center'>(TTY:711) <br /> Mon-Fri. 9 AM-5 PM PST</p>
            </div>

            <div className="bg-white p-4 rounded shadow-lg max-w-[27rem] flex flex-col items-center">
              <div className='text-center pt-2'><img src="Images\home-image-2.webp" alt="" /></div>
              <h3 className='text-center font-bold text-xl my-2'>Explore Your Medicare Options Online</h3>
              <p className='text-center text-gray-600 mx-4 mb-8'>Answer a few quick questions to help a licensed insurance agent understand your needs and review Medicare plan options available in your area. This process takes about 2 minutes.</p>
              <div className="flex justify-center mb-3">
                <Link to={'/medicare-intake-form'} className='btn-primary no-underline text-base px-6 py-2'>Start Medicare Intake</Link>
              </div>
              <div class="flex px-4 py-3 rounded relative" role="alert">
                <span class="block sm:inline text-xs">This is a solicitation for insurance. You may be contacted by a licensed insurance agent.</span>
              </div>
            </div>
            {/* Third column if needed, layout adjusted for 2 cols as per original content but grid supports 3 */}
          </div>
        </div>
      </div>

      {/* Section-1: Find Your Match */}
      <div className="py-8 lg:py-16 px-4 lg:px-[12rem] bg-white container mx-auto text-stone-600">
        <h2 className='text-center text-2xl lg:text-4xl font-bold mb-4'>Explore Your Medicare Options — Your Way</h2>
        <p className='text-center lg:px-20 text-gray-600 text-lg mb-12'>Choose how you’d like to learn about Medicare. Whether you prefer speaking with a licensed insurance agent, reviewing plans online, or scheduling a call, we’re here to help you understand your options.</p>

        <div className="container mx-auto">
          <div className="grid md:grid-cols-3 gap-6">
            <div className="flex flex-col items-center text-center">
              <div className='mb-4'><img src="Images\section-1-image-1.webp" className='h-40' alt="" /></div>
              <h4 className="font-bold text-xl mb-2">Speak With a Licensed Agent</h4>
              <span className='block py-1 text-gray-600 text-lg leading-snug'>Get guidance from licensed Boomers Insurance agent over the phone.</span>
              <h6 className="font-bold mt-4">Availability:</h6>
              <h5 className='font-bold'>Monday - Friday, 9 AM - 6 PM PST</h5>
              <div className='flex justify-center mt-2'>
                <div className="text-red-600 font-bold"> 📞 <a href="tel:+18008151943" className="hover:underline">1-800-815-1943</a> (TTY 711)</div>
              </div>
            </div>

            <div className="flex flex-col items-center text-center">
              <div className='mb-4 w-40 h-40 rounded-full flex items-center justify-center p-3 bg-gray-200'><img src="Images\section-1-image-2.webp" className='max-h-full' alt="" /></div>
              <h4 className="font-bold text-xl mb-2">Simply Enroll Online</h4>
              <span className='block py-1 text-gray-600 text-lg leading-snug'>Explore Medicare plan options available in your area, including coverage for doctors, prescriptions, and additional benefits.</span>
              <Link
                to="https://www.sunfirematrix.com/app/consumer/tbr/10730156"
                target="_blank"
                rel="noopener noreferrer"
                className='no-underline text-black hover:text-red-600'
              >
                <h6 className='font-bold mt-4 text-red-600'>🔍 See Plans in My Area</h6>
              </Link>
              <div class="flex mt-3 px-4 py-3 rounded relative" role="alert">
                <span class="block sm:inline text-xs">Results are based on available plans in your area.</span>
              </div>
            </div>

            <div className="flex flex-col items-center text-center">
              <div className='mb-4'><img src="Images\section-1-image-3.webp" className='h-40' alt="" /></div>
              <h4 className="font-bold text-xl mb-2">Schedule an Appointment</h4>
              <span className='block py-1 text-gray-600 text-lg leading-snug'>Book a time to speak with a licensed insurance agent at your convenience.</span>
              <h6 className='font-bold mt-4 text-red-600'><Link to={'https://boomersinsuranceservices.com/book/gaDWNhlQJ7QtlGbyCqAf86PJ5U3Wj3uf'}>📅 Book Appointment</Link></h6>
            </div>
          </div>
          <div class="flex px-4 py-3 rounded relative" role="alert">
            <span class="block sm:inline text-xs text-center">Medicare plan changes are subject to eligibility and qualifying enrollment periods. Not all consumers qualify to enroll in or change plans at any time of the year. A licensed insurance agent can help determine eligibility based on the consumer’s situation.</span>
          </div>
        </div>
      </div>

      {/* <div className="py-8 bg-gray-50">
        <h2 className='text-center text-xl lg:text-2xl font-bold px-4'>We work with a variety of Medicare-approved insurance carriers to offer plan options based on your location.</h2>
      </div>

      <div className="w-full overflow-hidden py-8 bg-white">
        <div className="flex w-max animate-logo-scroll-slow md:animate-logo-scroll">

          <div className="flex items-center gap-12 px-8">
            <img src="Images/section-1-logo-1.webp" className="h-12 object-contain" />
            <img src="Images/section-1-logo-2.webp" className="h-12 object-contain" />
            <img src="Images/section-1-logo-3.webp" className="h-12 object-contain" />
            <img src="Images/section-1-logo-4.webp" className="h-12 object-contain" />
            <img src="Images/section-1-logo-5.webp" className="h-12 object-contain" />
            <img src="Images/section-1-logo-6.webp" className="h-12 object-contain" />
            <img src="Images/section-1-logo-7.webp" className="h-12 object-contain" />
            <img src="Images/section-1-logo-8.webp" className="h-12 object-contain" />
            <img src="Images/section-1-logo-9.webp" className="h-12 object-contain" />
            <img src="Images/section-1-logo-10.webp" className="h-12 object-contain" />
            <img src="Images/section-1-logo-11.webp" className="h-12 object-contain" />
            <img src="Images/section-1-logo-12.webp" className="h-12 object-contain" />
            <img src="Images/section-1-logo-13.webp" className="h-12 object-contain" />
            <img src="Images/section-1-logo-14.webp" className="h-12 object-contain" />
            <img src="Images/section-1-logo-15.webp" className="h-12 object-contain" />
          </div>

          <div className="flex items-center gap-12 px-8">
            <img src="Images/section-1-logo-1.webp" className="h-12 object-contain" />
            <img src="Images/section-1-logo-2.webp" className="h-12 object-contain" />
            <img src="Images/section-1-logo-3.webp" className="h-12 object-contain" />
            <img src="Images/section-1-logo-4.webp" className="h-12 object-contain" />
            <img src="Images/section-1-logo-5.webp" className="h-12 object-contain" />
            <img src="Images/section-1-logo-6.webp" className="h-12 object-contain" />
            <img src="Images/section-1-logo-7.webp" className="h-12 object-contain" />
            <img src="Images/section-1-logo-8.webp" className="h-12 object-contain" />
            <img src="Images/section-1-logo-9.webp" className="h-12 object-contain" />
            <img src="Images/section-1-logo-10.webp" className="h-12 object-contain" />
            <img src="Images/section-1-logo-11.webp" className="h-12 object-contain" />
            <img src="Images/section-1-logo-12.webp" className="h-12 object-contain" />
            <img src="Images/section-1-logo-13.webp" className="h-12 object-contain" />
            <img src="Images/section-1-logo-14.webp" className="h-12 object-contain" />
            <img src="Images/section-1-logo-15.webp" className="h-12 object-contain" />
          </div>

        </div>
      </div>

      <div class="flex items-center justify-center px-4 py-3 rounded relative" role="alert">
        <span class="block sm:inline text-xs">We do not offer every plan available in your area. Any information we provide is limited to those plans we offer. Please contact Medicare.gov or 1-800-MEDICARE to review all available options.</span>
      </div> */}




      {/* Section-2: Learn about options */}
      <div className="py-16 px-4 lg:px-[12rem] bg-brand-red h-auto text-white">
        <div className="container mx-auto">
          <h2 className='text-center text-3xl font-bold mb-4'>Learn About Your Medicare Options</h2>
          <p className='text-center lg:px-20 mb-12 text-lg'>Medicare coverage is not one-size-fits-all. We provide educational guidance to help you understand available options and review plans based on your needs and location.</p>

          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-white rounded-lg shadow-md overflow-hidden mx-auto max-w-[25rem] h-full flex flex-col">
              <img src="/Images/home-section2-image-2.webp" className='w-full h-48 object-cover' alt="" />
              <h4 className='font-bold text-xl mt-4 px-4 text-gray-700'>Medicare Advantage Plans (Part C)</h4>
              <p className='px-4 mt-2 text-gray-600 text-lg'>Medicare Advantage plans are offered by private insurers approved by Medicare and may include additional benefits beyond Original Medicare such as prescription drug coverage and more.</p>
              <p className='px-4 mt-2 text-gray-600 text-md'>Not all plans offer all benefits.</p>
            </div>

            <div className="bg-white rounded-lg shadow-md overflow-hidden mx-auto max-w-[25rem] h-full flex flex-col">
              <img src="/Images/home-section2-image-1.webp" className='w-full h-48 object-cover' alt="" />
              <h4 className='font-bold text-xl mt-4 px-4 text-gray-700'>Medicare Supplement (Medigap) Plans</h4>
              <p className='px-4 mt-2 text-gray-600 text-lg'>Medigap plans help cover certain out-of-pocket costs not paid by Original Medicare, such as copayments, coinsurance, and deductibles.</p>
              <p className='px-4 mt-2 text-gray-600 text-md'>Plans are standardized but availability may vary by state.</p>
            </div>

            <div className="bg-white rounded-lg shadow-md overflow-hidden mx-auto max-w-[25rem] h-full flex flex-col">
              <img src="/Images/home-section2-image-3.webp" className='w-full h-48 object-cover' alt="" />
              <h4 className='font-bold text-xl mt-4 px-4 text-gray-700'>Prescription Drug Plans (Part D)</h4>
              <p className='px-4 mt-2 text-gray-600 text-lg'>Prescription Drug Plans provide coverage for medications and are offered by Medicare-approved private insurers.</p>
              <p className='px-4 mt-2 text-gray-600 text-md'>Costs and covered medications vary by plan.</p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default Home
